import { render, staticRenderFns } from "./FullRegPayment.vue?vue&type=template&id=380d94c1&scoped=true"
import script from "./FullRegPayment.vue?vue&type=script&lang=js"
export * from "./FullRegPayment.vue?vue&type=script&lang=js"
import style0 from "./FullRegPayment.vue?vue&type=style&index=0&id=380d94c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d94c1",
  null
  
)

export default component.exports